import { createAction } from 'react-async-client';

import * as actions from 'constants/actionTypes';

export const logout = createAction(actions.LOGOUT);
export const toggleFeedbackModal = createAction(actions.TOGGLE_FEEDBACK_MODAL);




// WEBPACK FOOTER //
// ./src/actions/appActions.js